// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ag-value-row {
  
}
.icon {
  width: 32px;
  height: 32px;
  margin: 0;
}
.ag-value {
  font-size: 24px;
  width: 100px;
}
.ag-value-label {
  font-size: 16px;
  max-width: 140px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre;
}
.ag-value-section {
  margin-left: 5px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/base-components.ts"],"names":[],"mappings":";;AAEA;;AAEA;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["\n\n.ag-value-row {\n  \n}\n.icon {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n}\n.ag-value {\n  font-size: 24px;\n  width: 100px;\n}\n.ag-value-label {\n  font-size: 16px;\n  max-width: 140px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: pre;\n}\n.ag-value-section {\n  margin-left: 5px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
